import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { HttpUtilService } from '../config/http-util.service';

@Injectable()
export class AboutService {

    private controller = 'company';

    constructor(private _http: Http, private _httpUtil: HttpUtilService) {
    }

    getData(): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller))
        .map(res => res.json())
        .catch(err => Observable.throw(err.message));
    }

    getImages(): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller + '/gallery/image/asc'))
        .map(res => res.json())
        .catch(err => Observable.throw(err.message));
    }
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/about/about.service.ts